<template>
    <div>
        <hts-router-drawer
            :title="$t('labels.replicateBusinessOpportunity')"
            :size="70"
            :submit="submit"
            is-close
            :rules="CRulesBusinessOpportunity"
            :disabled="!dataChanged"
            @loaded="getData"
            @refresh-tables="refreshTables">
            <hts-card :title="$t('labels.shippingInformation')">
                <hts-select-work-flow
                    v-model="formData.workflow"
                    v-model:name="formData.workflowDetail.name"
                    prop="workflow"
                    @change="handelChangeSelectWorkFlow" />
                <div
                    v-if="formData.positions.length > 0"
                    v-loading="loadingSelectNode">
                    <span class="text-base block px-0 font-medium text-default-500">
                        {{ $t('labels.route') }}
                    </span>

                    <div class="overflow-x-auto pb-2">
                        <div :style="{ minWidth: minWidthScroll }">
                            <div
                                v-for="(item, index) in formData.positions"
                                :key="index"
                                class="pl-10">
                                <div class="flex items-center w-full gap-5">
                                    <hts-select-node
                                        v-model="formData.positions[index].node"
                                        v-model:name="formData.positions[index].fullNameNode"
                                        :node-type-id="item.nodeType"
                                        :prop="item.nodeType + index"
                                        :label="item.nodeTypeName"
                                        :businesses="item.businesses"
                                        :param-prepare="formData.workflow"
                                        required
                                        class="w-full"
                                        @change="(val: any[]) => handelChangeSelectNode(index, val)" />
                                    <hts-form-button
                                        icon-name="hi-pencil-square-icon"
                                        size="small"
                                        class="w-[26rem] mt-9"
                                        color="info"
                                        :loading="updateCompletionTime"
                                        @click="()=> openWorkflowPosition(item as any)">
                                        {{ $t('labels.editCompletionTime') }}
                                    </hts-form-button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="text-right mt-4">
                        <span
                            class="right-20 text-lg text-blue-600 cursor-pointer italic"
                            @click="openWithMap">
                            {{ $t('labels.openWithMap') }}
                        </span>
                    </div>
                </div>
                <div v-if="formData.transportation">
                    <div v-if="formData.transportation === 'CONTAINER'">
                        <hts-form-select
                            v-model="formData.contCategory"
                            :label="$t('labels.containerType')"
                            :clearable="true"
                            required
                            :items="dataSelectWorkFlowData"
                            key-id="value"
                            key-label="label"
                            prop="workflowData"
                            name="workflowData"
                            :color="props.color"
                            @change="changeCategory" />
                    </div>
                    <div v-else>
                        <hts-select-category-vehicle
                            v-model="formData.vehicleCategory"
                            v-model:name="formData.vehicleCategoryName"
                            required
                            prop="workflowData"
                            @change="changeCategory" />
                    </div>
                </div>
                <hts-form-input
                    v-model="formData.productivity"
                    :label="$t('labels.productivityByMount')"
                    type="number"
                    required
                    prop="productivity"
                    name="productivity"
                    :color="props.color">
                    <template #suffix>
                        <span>
                            {{ formData.transportation ? (formData.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')) : '-' }}
                        </span>
                    </template>
                </hts-form-input>
                <hts-form-input
                    v-model="formData.weightCommodity"
                    :label="$t('labels.weightCommodityByKG1')"
                    type="number"
                    required
                    prop="weightCommodityByKG"
                    name="weightCommodityByKG1"
                    :color="props.color">
                    <template #suffix>
                        <span>
                            {{ formData.transportation ? `/${formData.transportation === 'CONTAINER' ? $t('labels.cont') : $t('labels.vehicle')}` : '-' }}
                        </span>
                    </template>
                </hts-form-input>
            </hts-card>

            <hts-card :title="$t('labels.commodityInfo')">
                <hts-select-commodity
                    v-model="formData.commodity"
                    :name="formData?.commodityDetail?.commodity"
                    required
                    multiple
                    :cooperator-id="cooperatorId"
                    :data-select-multiple="formData.commodityDetail"
                    creatable
                    :function-create-new="openAddCommodity"
                    prop="commodity" />
                <hts-form-radio
                    v-model="formData.typeReefer"
                    :label="$t('labels.isReefer')"
                    required
                    value-key="value"
                    :items="listRadioReeferTypes" />
                <hts-form-radio
                    v-model="formData.typeDangerous"
                    :label="$t('labels.isDangerous')"
                    required
                    value-key="value"
                    :items="listRadioDangerousTypes" />
                <hts-form-radio
                    v-model="formData.typeFragileGoods"
                    :label="$t('labels.isFragile')"
                    required
                    value-key="value"
                    :items="listRadioFragileTypes" />
                <!--
                  <hts-form-radio
                  v-model="formData.goodType"
                  :label="$t('labels.goodsTypes')"
                  required
                  value-key="value"
                  :items="listRadioGoodTypes" />
                -->
                <!--
                  <hts-form-radio
                  v-model="formData.typeCommodity"
                  :label="$t('labels.overweightCargo2')"
                  required
                  value-key="value"
                  :items="listRadioTypeCommodity" />
                -->
            </hts-card>
            <add-commodity ref="addCommodity" />
            <map-position
                ref="mapPosition"
                key-map-store="businessOpportunity"
                @applyPosition="handleApplyPositionMap" />
        </hts-router-drawer>

        <workflow-position
            ref="workflowPosition"
            @update="(val) => updateWorkflowPosition(val)" />
    </div>
</template>

<script setup lang="ts">
import MapPosition from '../-components/position.vue'
import WorkflowPosition from '../-components/workflow-position.vue'
import { IWorkflowPosition } from '../../../../../admincp/workflow/-imports/form'
import { $api, $lodash } from '#imports'
import { IBusinessOpportunity } from '~/pages/trucker-[id]/partner/-components/imports/form'
import AddCommodity from '~/pages/trucker-[id]/partner/[idpartner]/commodity/-components/add-commodity.vue'

import screen from '~/components/utils/screen'
const store = $store()

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  }
})
const breakpoint = screen()
const minWidthScroll = computed(() => {
  return `${breakpoint.value.thresholds.sm}px`
})

const dataChanged = ref(false)
const workflowPosition = ref()
// kiểm tra có đang call api update thời gian hoàn  thành tác vụ không
const updateCompletionTime = ref(false)

const configCont: { [key: string]: any } = computed(() => store.globalSettings.getGlobalSettings.configCont)
const configVehicle: { [key: string]: any } = computed(() => {
  return store.data.getVehicleCategories
})

const { $disableReactive } = useNuxtApp()
const addCommodity: any = ref(null)
const openAddCommodity = () => {
  if (addCommodity.value) {
    addCommodity.value.open(cooperatorId.value)
  }
}

const information = ref([])
const visible = ref(false)
const creating = ref(false)
const loading = ref(false)

const formData = reactive<IBusinessOpportunity>({
  workflow: '',
  route: [],
  commodity: [],
  typeCommodity: 'NORMAL',
  typeReefer: 'NOTREEFER',
  goodType: 'SOLID',
  typeDangerous: 'NOTDANGEROUS',
  typeFragileGoods: 'NOTFRAGILE',
  weightCommodity: null,
  contCategory: '',
  vehicleCategory: '',
  vehicleCategoryName: '',
  quote: '',
  productivity: null,
  transportation: '',
  positions: [],
  theSamePositions: [],
  commodityDetail: {
    commodity: ''
  },
  workflowDetail: {
    name: ''
  }
})

const rulesBusinessOpportunity = {
  productivity: 'required|integer',
  weightCommodityByKG: 'required'
}
const CRulesBusinessOpportunity = computed(() => {
  const result = { ...{}, ...$disableReactive(rulesBusinessOpportunity) }
  if (formData.transportation === 'CONTAINER' && formData.contCategory) {
    if (configCont.value && configCont.value[formData.contCategory] && configCont.value[formData.contCategory].weightCargo) {
      result.weightCommodityByKG = `required|validationCustom:${
        formData.weightCommodity && formData.weightCommodity <= configCont.value[formData.contCategory].weightCargo
      }--
      ${$t('labels.checkWeightContainer')} - ${configCont.value[formData.contCategory].weightCargo}`
    }
  } else if (formData.transportation === 'NON_CONTAINER' && formData.vehicleCategory && configVehicle.value) {
    const findVehicleCategory = configVehicle.value.find((findVehicleCategory: { [key: string]: any }) => {
      return findVehicleCategory._id === formData.vehicleCategory
    })
    if (findVehicleCategory) {
      const min = Number(findVehicleCategory.from || 0)
      const max = Number(findVehicleCategory.to || 999999999999999)
      result.weightCommodityByKG = `required|validationCustom:
      ${formData.weightCommodity && min <= formData.weightCommodity && formData.weightCommodity < max}--
      ${$t('labels.checkWeightVehicle')} (${min} <= ${$t('labels.weightCommodity')} < ${max})`
    }
  }
  return result
})

const resetForm = () => {
  Object.assign(formData, {
    workflow: '',
    route: [],
    commodity: [],
    typeCommodity: 'NORMAL',
    typeReefer: 'NOTREEFER',
    goodType: 'SOLID',
    typeDangerous: 'NOTDANGEROUS',
    typeFragileGoods: 'NOTFRAGILE',
    weightCommodity: null,
    contCategory: '',
    vehicleCategory: '',
    vehicleCategoryName: '',
    quote: '',
    productivity: null,
    transportation: '',
    positions: [],
    theSamePositions: [],
    commodityDetail: {
      commodity: ''
    }
  })
}

const close = () => {
  visible.value = false
}

const cooperatorId = computed(() => useRoute().params.idpartner)
const businessOpportunityId = computed(() => useRoute().params.idbusinessopportunity)

const emits = defineEmits(['refreshTables'])

const refreshTables = () => {
  emits('refreshTables')
}
const dataWorkflow = ref<{ [key: string]: any }>({})

const dataSelectWorkFlowData = [
  {
    value: 20,
    label: $t('labels.vehicleModule.20ft')
  },
  {
    value: 40,
    label: $t('labels.vehicleModule.40ft')
  },
  {
    value: 45,
    label: $t('labels.vehicleModule.45ft')
  }
]

const openWorkflowPosition = (position: IWorkflowPosition) => {
  if (workflowPosition.value) {
    workflowPosition.value.open($disableReactive(position), dataWorkflow.value.transportation)
  }
}

const updateWorkflowPosition = (position: IWorkflowPosition) => {
  const index = position.index - 1
  formData.positions[index] = position
}

const submit = async () => {
  const api = $url.partner.businessOpportunity.replicate
  creating.value = true
  const result = await $api(api, { body: { ...formData, ...{ replicate: true } }, uriParams: { cooperatorId: cooperatorId.value } })
  try {
    if (result) {
      const responseData: any = result?.data?.value
      if (responseData?.success) {
        process.client && $toast().success($t('labels.replicateBusinessOpportunitySuccess'))
        return
      }
      throw new Error(' ')
    }
  } catch (e: any) {
    throw new Error(' ')
  }
}
const handelChangeSelectWorkFlow = async (val: any) => {
  if (Array.isArray(val) && val.length) {
    const temp = val[0] ?? {}
    dataWorkflow.value = temp
  } else {
    dataWorkflow.value = []
  }
  setDataFromWorkflow()
  await changeCategory()
}
const setDataFromWorkflow = () => {
  formData.transportation = dataWorkflow.value.transportation || ''
  formData.positions = dataWorkflow.value.positions || []
  formData.theSamePositions = dataWorkflow.value.theSamePositions || []
  formData.contCategory = ''
  formData.vehicleCategory = ''
  formData.vehicleCategoryName = ''
}
const typeNameRoute = (type: string) => {
  if (!type) {
    return null
  }
  switch (type) {
  case 'PORT':
    return $t('labels.nodeModule.port')
  case 'DEPOT':
    return $t('labels.nodeModule.depot')
  case 'ICD':
    return $t('labels.nodeModule.icd')
  case 'WAREHOUSE':
    return $t('labels.nodeModule.warehouse')
  case 'HUB':
    return $t('labels.nodeModule.hub')
  case 'TOLL_STATION':
    return $t('labels.nodeModule.tollStation')
  default:
    break
  }
}

const changeCategory = async () => {
  await setDataPosition()
}

// cập nhật lại thời gian tác vụ khi loại xe loại cont thay đổi
watch(
  () => formData.vehicleCategory,
  async () => {
    await changeCategory()
  }
)

watch(
  () => formData.contCategory,
  async () => {
    await changeCategory()
  }
)

// gọi api tính thời gian hoàn thành của chkd
const setDataPosition = async () => {
  try {
    const api = $url.partner.businessOpportunity.timeCompletePositions
    if (cooperatorId.value && formData.transportation && (formData.contCategory || formData.vehicleCategory)) {
      updateCompletionTime.value = true
      const body = {
        transportation: formData.transportation,
        positions: formData.positions,
        contCategory: formData.contCategory,
        vehicleCategory: formData.vehicleCategory,
        cooperator: cooperatorId.value
      }
      const data: any = await $api(api, { body, uriParams: { cooperatorId: cooperatorId.value } })
      const resData = data?.data?.value
      if (resData && resData.success) {
        formData.positions = resData.data
      }
      updateCompletionTime.value = false
    }
  } catch (e) {}
}

const loadingSelectNode = ref(false)
const handelChangeSelectNode = async (indexRoute: number, val: Array<{ [key: string]: any }>) => {
  loadingSelectNode.value = true
  const nodeTheSame: Array<number> | undefined = getNodeTheSamePosition(indexRoute, $disableReactive(formData.theSamePositions))
  if (Array.isArray(val) && val.length && typeof val[0].location === 'string') {
    let dataPosition: { [key: string]: any } = {}
    const api = $urlAdmin.node.location.detail
    const res = await $api(api, { uriParams: { ID: val[0].location } })
    const resData: any = res?.data?.value
    if (resData?.success) {
      dataPosition = resData.data
    }
    if (dataPosition) {
      formData.positions[indexRoute].lat = val[0]?.locationData?.[0]?.lat || dataPosition.lat
      formData.positions[indexRoute].lng = val[0]?.locationData?.[0]?.lng || dataPosition.lng
      if (Array.isArray(nodeTheSame)) {
        nodeTheSame.forEach((numberRoute: number) => {
          if (numberRoute !== indexRoute) {
            if (Array.isArray(dataPosition.nodeDetail) && dataPosition.nodeDetail.length) {
              let findItemPosition = dataPosition.nodeDetail.find((itemNode: { [key: string]: any }) => {
                return itemNode.nodeType && itemNode.nodeType.name === formData.positions[numberRoute].nodeTypeName
              })
              const businessAndTask = checkBusinessAndTask(findItemPosition, formData.positions[numberRoute])
              if (businessAndTask) {
                findItemPosition = undefined
              }
              formData.positions[numberRoute].node = findItemPosition?._id || ''
              formData.positions[numberRoute].fullNameNode = findItemPosition?.fullNameNode || ''
              formData.positions[numberRoute].lat = val[0]?.locationData?.[0]?.lat || dataPosition.lat
              formData.positions[numberRoute].lng = val[0]?.locationData?.[0]?.lng || dataPosition.lng
            } else {
              formData.positions[numberRoute].node = ''
              formData.positions[numberRoute].fullNameNode = ''
              formData.positions[numberRoute].lat = ''
              formData.positions[numberRoute].lng = ''
            }
          }
        })
      }
    }
  } else {
    formData.positions[indexRoute].lat = ''
    formData.positions[indexRoute].lng = ''
    nodeTheSame &&
      nodeTheSame.forEach((numberRoute: number) => {
        if (numberRoute !== indexRoute) {
          formData.positions[numberRoute].node = ''
          formData.positions[numberRoute].fullNameNode = ''
          formData.positions[numberRoute].lat = ''
          formData.positions[numberRoute].lng = ''
        }
      })
  }
  await changeCategory()
  loadingSelectNode.value = false
}

const getNodeTheSamePosition = (index: number, data: Array<Array<number>>) => {
  if (typeof index !== 'number' || !Array.isArray(data)) {
    return
  }
  let result: Array<number> = []
  const filteredItems = data.filter((i: Array<number>) => i.includes(index))
  const tempData = data.filter((i: Array<number>) => !i.includes(index))
  filteredItems.forEach((item) => {
    if (!Array.isArray(item) || item.length !== 2) {
      return
    }
    const tempIndex = item.findIndex((o) => o === index)
    let tempIndex2
    if (tempIndex === 0) {
      tempIndex2 = 1
    } else {
      tempIndex2 = 0
    }

    result.push(item[1])
    result.push(item[0])

    const itemNodeTheSames: Array<number> | undefined = getNodeTheSamePosition(item[tempIndex2], tempData)
    if (Array.isArray(itemNodeTheSames)) {
      result = result.concat(itemNodeTheSames)
    }
  })
  return $lodash.uniq(result)
}

const stopWatching = ref()

const getData = async () => {
  const api = $url.partner.businessOpportunity.getDetail
  const data: any = await $api(api, { uriParams: { cooperatorId: cooperatorId.value, ID: businessOpportunityId.value } })
  const resData: any = data.data.value
  if (resData?.success) {
    loading.value = true
    Object.assign(formData, { ...resData.data })
    formData.vehicleCategoryName = resData.data?.vehicleCategoryDetail?.name
  }
  dataChanged.value = false

  setTimeout(() => {
    stopWatching.value = setupWatch(
      (val: any) => {
        dataChanged.value = true
      },
      { deep: true }
    )
  }, 1000)
}

const setupWatch = (func: Function, options?: { [key: string]: any }) => {
  const stopWatching = watch(
    () => formData,
    (val) => func(val),
    options
  )

  // Return the stop function so you can stop watching when needed
  return stopWatching
}

onUnmounted(() => {
  typeof stopWatching.value === 'function' && stopWatching.value()
})

const listRadioTypeCommodity = [
  { value: 'NORMAL', label: $t('labels.ordinaryGoods') },
  { value: 'OVERWEIGHT', label: $t('labels.overweightCargo') }
]

const listRadioGoodTypes = [
  { value: 'SOLID', label: $t('labels.solid') },
  { value: 'LIQUID', label: $t('labels.liquid') },
  { value: 'GAS', label: $t('labels.gas') }
]
const listRadioDangerousTypes = [
  { value: 'NOTDANGEROUS', label: $t('labels.notDangerous') },
  { value: 'DANGEROUS', label: $t('labels.dangerous') }
]
const listRadioFragileTypes = [
  { value: 'NOTFRAGILE', label: $t('labels.notFragile') },
  { value: 'FRAGILE', label: $t('labels.fragile') }
]
const listRadioReeferTypes = [
  { value: 'NOTREEFER', label: $t('labels.no') },
  { value: 'REEFER', label: $t('labels.true') }
]

const mapPosition = ref()

const openWithMap = () => {
  mapPosition.value && mapPosition.value.open($disableReactive(formData.positions), $disableReactive(formData.theSamePositions))
}

const handleApplyPositionMap = (positions: Array<{ [key: string]: any }>) => {
  formData.positions = $disableReactive(positions)
}
const checkBusinessAndTask = (node: { businesses: { [key: string]: Array<string> } }, route: { [key: string]: any }): boolean => {
  if (!route.businesses || !Object.keys(route.businesses).length) {
    return false
  }
  return Object.keys(route.businesses).some((item: string) => {
    if (!node || !node.businesses || !Object.keys(node.businesses).length || !node?.businesses[item]) {
      return true
    }
    return route.businesses[item].some((task: string) => {
      return !node?.businesses[item].includes(task)
    })
  })
}
</script>
